const API_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_ENDPOINT;

export default API_BASE_URL;
